import React from 'react';
import { Card } from "react-bootstrap";
import styles from '../SessionHistoryDetailView.module.css';

const MentalStatusConcernsSection = ({
  sessionFormData,
  updateFormData,
  appearanceError,
  behaviorError,
  speechError,
  moodError,
  affectError,
  thoughtProcessError,
  orientationError,
  insightJudgmentError,
  setAppearanceError,
  setBehaviorError,
  setSpeechError,
  setMoodError,
  setAffectError,
  setThoughtProcessError,
  setOrientationError,
  setInsightJudgmentError
}) => {
  const mentalStatusFields = [
    {
      label: "Appearance",
      key: "appearance",
      options: [
        "Appropriate",
        "Disheveled",
        "Poor hygiene",
        "Well-groomed",
        "Unkempt",
        "Bizarre/unusual attire"
      ]
    },
    {
      label: "Behavior",
      key: "behavior",
      options: [
        "Calm/cooperative",
        "Guarded",
        "Agitated",
        "Withdrawn",
        "Restless",
        "Hostile",
        "Impulsive"
      ]
    },
    {
      label: "Speech",
      key: "speech",
      options: [
        "Normal rate/tone",
        "Rapid",
        "Slow",
        "Pressured",
        "Monotone",
        "Slurred",
        "Minimal"
      ]
    },
    {
      label: "Mood",
      key: "mood",
      options: [
        "Euthymic (normal)",
        "Anxious",
        "Depressed",
        "Irritable",
        "Labile",
        "Angry",
        "Elevated"
      ]
    },
    {
      label: "Affect",
      key: "affect",
      options: [
        "Appropriate",
        "Flat",
        "Blunted",
        "Restricted",
        "Labile",
        "Incongruent"
      ]
    },
    {
      label: "Thought Process",
      key: "thoughtProcess",
      options: [
        "Logical/coherent",
        "Goal-directed",
        "Tangential",
        "Circumstantial",
        "Disorganized",
        "Flight of ideas"
      ]
    },
    {
      label: "Orientation",
      key: "orientation",
      options: [
        "Oriented x3 (person/place/time)",
        "Disoriented",
        "Unsure",
        "Not assessed"
      ]
    },
    {
      label: "Insight/Judgment",
      key: "insightJudgment",
      options: [
        "Intact",
        "Fair",
        "Limited",
        "Poor",
        "Impaired"
      ]
    }
  ];

  const handleMentalStatusChange = (key, value) => {
    updateFormData(key, value);
    if (key === "appearance" && appearanceError) {
      setAppearanceError("");
    } else if (key === "behavior" && behaviorError) {
      setBehaviorError("");
    } else if (key === "speech" && speechError) {
      setSpeechError("");
    } else if (key === "mood" && moodError) {
      setMoodError("");
    } else if (key === "affect" && affectError) {
      setAffectError("");
    } else if (key === "thoughtProcess" && thoughtProcessError) {
      setThoughtProcessError("");
    } else if (key === "orientation" && orientationError) {
      setOrientationError("");
    } else if (key === "insightJudgment" && insightJudgmentError) {
      setInsightJudgmentError("");
    }
  };

  const getFieldError = (key) => {
    switch (key) {
      case "appearance":
        return appearanceError;
      case "behavior":
        return behaviorError;
      case "speech":
        return speechError;
      case "mood":
        return moodError;
      case "affect":
        return affectError;
      case "thoughtProcess":
        return thoughtProcessError;
      case "orientation":
        return orientationError;
      case "insightJudgment":
        return insightJudgmentError;
      default:
        return "";
    }
  };

  return (
    <Card id="mental-status" className={styles.card}>
      <h3 className={styles.sectionHeading}>
        Mental Status Exam
      </h3>

      <div className={styles.mentalStatusContainer}>
        {mentalStatusFields.map((field) => {
          const fieldError = getFieldError(field.key);
          return (
            <div key={field.label} className={styles.mentalStatusField}>
              <label className={styles.labelWithMarginXLarge}>
                {field.label}:
              </label>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <select
                  value={sessionFormData[field.key] || ""}
                  onChange={(e) => handleMentalStatusChange(field.key, e.target.value)}
                  className={styles.selectMediumWidth}
                >
                  <option value="">–</option>
                  {field.options.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
                {fieldError && (
                  <div className={styles.errorMessage} style={{ marginTop: "4px", marginBottom: "8px" }}>
                    {fieldError}
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </Card>
  );
};

export default MentalStatusConcernsSection;

